import { api, formatErr } from "@/lib/api";

export async function uploadImage(file) {
  if (file.size > 5 * 1024 * 1024) throw new Error("Image must be 5 MB or smaller");
  const fd = new FormData();
  fd.append("file", file);
  try {
    const { data } = await api.post("/admin/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
    return data.url;
  } catch (e) { throw new Error(formatErr(e)); }
}
